import Vue from 'vue'
import VSwatches from 'vue-swatches'

Vue.component('v-swatches', VSwatches)
